<template>

  <div v-loading="loading">
    <el-card>
      <div style="margin: 0 0 6px 0; color: #999" v-if="!!this.missingRows">{{ "," +
        $t("message.title.missingRows")
      }}</div>
      <div class="show-table">
        <vxe-grid v-bind="gridOptions" :scroll-y="{ enabled: true }" :toolbar-config="tableToolbar"
          @cell-dblclick='cellClick' :row-style="rowStyle"
          :cell-style="{ padding: '3px', 'font-size': '12px', 'line-height': '16px ' }">
        </vxe-grid>
        <el-pagination small class="pagination" background @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :page-sizes="[100, 200, 500, 1000]" :page-size="1000"
          :current-page='currentPage' layout="total, sizes, prev, pager, next, jumper" :total="totalRecords">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>
<script>
import axios from "axios";
import SearchQuery from "./searchItem/search.vue";
import { setColumns } from './showTable';
import { LINK_LIST } from "@/utils/constants";
export default {
  name: "simpleSearch",
  data() {
    return {

      loading: false,
      tableShow: false,

      pageSizes: [100, 200, 500, 1000],
      pageSize: 1000,
      currentPage: 1,
      totalRecords: 0,
      missingRows: 0,

      select_value: "",
      tableToolbar: {
        buttons: [{ code: 'myInsert', name: '', type: 'text', },],
        // print: true,
        // print: true,
        // export:true,
        zoom: true,
        custom: true,
        // slots: {
        //   tools: "tools",
        // },
      },
      gridOptions: {

        printConfig: {},
        keepSource: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,

        rowId: "id",
        size: "small",
        border: true,
        resizable: true,
        showOverflow: true,
        stripe: true,
        height: 660,
        align: 'left',
        columns: [],
        data: []
      },
      rowStyle: { cursor: 'pointer' },
    };
  },
  components: {
    SearchQuery,
  },
  computed: {
    getPage() {
      const { id, val } = this.$route.query
      console.log(id, val);

      return { id, val }
    },
  },
  watch: {
    getPage(newVal) {
      // console.log(val);
      const { id, val } = newVal
      this.setSearch({ 'value': val });
    }
  },
  mounted() { },
  methods: {

    handleSizeChange(val) {
      this.pageSize = val;
      this.setSearch({ size: val });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.setSearch({ page: val });
      // const { data: res } = await this.$http.get(loadTableUrl);
    },
    baseIdChange() {
      this.currentPage = 1;
    },

    cellClick({ row, }) {
      this.rowClick(row);
    },
    rowClick(row, column, event) {
      this.getLink(row.objectId);
    },


    async setSearch(obj) {
      //简单搜索：当用户点击搜索时把page设置为1
      if ('value' in obj) {
        this.currentPage = 1;
      }

      this.loading = true;

      const { query } = this.$route;
      const { id, val: value, size, page } = query;

      const param = { baseClassId: Number(id), value, 'size': this.pageSize || Number(size), 'page': this.currentPage || Number(page), id, ...obj };

      const urlMap = new Map([
        [301, `/ppm/project/simpleSearch`],
        [401, `/pqm/quality/simpleSearch`]
      ])
      const url = urlMap.get(Number(id)) || `/pmdm/search/simpleSearch`;

      const { data } = await axios.post(url, param);
      const { columnInfo, rows, totalRecords, rowMissing } = data.object.table
      this.showTable({ columnInfo, rows });
      this.records = { totalRecords, rowMissing };
      this.totalRecords = totalRecords
      this.loading = false
    },


    setTableInfo({ totalRecords, rowMissing }) {
      this.tableToolbar.buttons[0].name = this.$t('message.title.totalResults') + totalRecords + this.$t('message.title.resultsNums');
      this.missingRows = rowMissing;
    },

    showTable({ columnInfo, rows }) {

      this.gridOptions.columns = setColumns(columnInfo);
      this.gridOptions.columns.map((item, index) => {
        // const { attrId } = item;
        if (item.field == '0') {
          item.slots = {
            default: ({ row, column }, h) => {
              // 渲染链接
              return [
                <span
                  class="link_"
                  onClick={() => this.rowClick(row, column)}
                >
                  {row[column.property]}
                </span>,
              ];
            },
          };
        }
        return item
      });
      this.gridOptions.data = rows.map(i => {
        const row = {}, { cells, objId: id, objClass: classId, objSubClass: subClassId } = i;
        cells.map((j, e) => {
          row[e] = j?.val || ''
        })
        row.objectId = {
          subClassId, classId, id,
          title: cells[0].val
        }
        return row;
      })

    },

  },

  created() {
    // this.getSearchSelect();
    this.setSearch({});
    // this.select_value = this.$store.state.search_value.id;
    // this.$store.commit('setIncludesList', 'simpleSearch')
  },

};
</script>

<style lang="scss" scoped>
.link_ {
  color: #4b92ff;
  cursor: pointer;

  &:hover {
    // color: #4b92ff;
    border-bottom: 1px solid #4b92ff;
  }
}
</style>